/** @format */


export default {
    namespaced:true,
    state: {
        loginDialogShow: false,
        stateDialogShow: false,
    },
    mutations: {
        switchLoginStatus(state, val) {
            state.loginDialogShow = val;
        },
        switchState(state, val) {
            state.stateDialogShow = val;
        }
    },
    actions: {
    }
}



// WEBPACK FOOTER //
// ./src/store/module/collect.js